import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const FeaturedOnRow = styled(Row)`
  margin: 28px ${({ theme }) => theme.x4spacePx}px 0;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x2spacePx}px 0;
  `}
  align-items: center;
  img {
    ${media.mdUp`
      width: 70%;
    `}
    ${media.lgUp`
      width: 35%
      margin: 0 75px 0 0;
      &:nth-child(3) {
        margin: 0;
      }
    `};
  }

  > p {
    width: 100%;
    ${({ theme }) => theme.typography.small};
    ${media.lgUp`
      width: auto;
      ${({ theme }) => theme.typography.large};
      margin: 0 72px 0 0;
    `}
    text-align: center;
    color: ${({ theme }) => theme.color.blackRGBA(0.4)};
  }
`;
